/**
 * RESPONSIBILITY: one letter of the church's name, and what it stands for.
 *
 * A row, not a paragraph with the letters typed in capitals, so the page can set each
 * letter large and the words beside it — and so the name can be re-read in a different
 * order or grow a letter without anybody touching the layout.
 */
import { Row, Text } from '@framework/core/decorators';

@Row()
export class LetterRow {
  @Text({ label: 'Letter', maxLength: 3, description: 'e.g. A.' })
  letter!: string;

  @Text({ label: 'What it stands for', maxLength: 200, description: 'e.g. Adores and worships God.' })
  meaning!: string;
}
